import React from "react";
import { Container, Divider, Typography } from "@mui/material";

export default function Footer() {
  return (
    <footer className="bg-white text-black">
      {/* Divider */}
      <Divider className="border-gray-800" />

      {/* Footer Content */}
      <div className="bg-gray-50 py-8">
        <Container className="flex justify-between items-center md:flex-row flex-col">
          {/* Copyright Text */}
          <Typography
            variant="body2"
            className="text-gray-400 md:text-sm !text-xs"
          >
            © 2025 Rohan's Tax Services • All Rights Reserved
          </Typography>

          {/* Navigation */}
          <div className="flex md:space-x-4 space-x-2 md:mt-0 mt-2 items-center">
            {["Blogs", "Testimonials", "Services", "Contact"].map(
              (item, index) => (
                <a
                  key={index}
                  href={`/#${item.toLowerCase()}`}
                  className="text-gray-400 hover:text-black md:text-sm text-xs"
                >
                  {item}
                </a>
              )
            )}
            <a
              href="/privacypolicy"
              className="text-gray-400 hover:text-black md:text-sm text-xs"
            >
              Privacy Policy
            </a>
          </div>
        </Container>
      </div>
    </footer>
  );
}
